module.exports = __webpack_public_path__ + "img/french-southern-territories.9eb724ed.svg";